import React, { useEffect, useState } from 'react'
import { WebsiteThemeInterface } from 'src/editor/store/website-settings/website-settings-types'
import { WebsiteThemeBase } from 'src/editor/website/styles/themes/website-theme-base'
import { WebsiteThemeDropdownGroupSection } from 'src/editor/website/styles/themes/website-theme-group-section'
import { getWebsiteTheme } from 'src/editor/store/website-settings/website-settings-selector'
import { useWebsiteSettings } from 'client/store'

export const WebsiteStylesSettingsThemesAndColors = () => {
  const savedTheme = useWebsiteSettings(
    getWebsiteTheme,
  ) as WebsiteThemeInterface
  const [currentTheme, setCurrentTheme] =
    useState<null | WebsiteThemeInterface>(null)

  useEffect(() => {
    setCurrentTheme(savedTheme)
  }, [savedTheme])

  return (
    <>
      <WebsiteThemeBase onReset={() => setCurrentTheme(savedTheme)} />
      <WebsiteThemeDropdownGroupSection theme={currentTheme} />
    </>
  )
}
